import { fabric } from "fabric";

const Grass = fabric.util.createClass(fabric.Group, {
  type: "grass",
});

fabric.Grass = Grass;
